module.exports = __webpack_public_path__ + "static/Cerulli-0836748fe191a49a11197545d7cbd029.jpg";